module.exports = __webpack_public_path__ + "img/discount-bg.b962ad45.png";